/**
 * Settings component exports
 *
 * @since 1.0.0
 */

export { Settings } from './component';
export type { PageOption, SettingsData, SettingsTab } from './types';
